import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { environment } from '@env/environment'
import { Observable } from 'rxjs'
import { map } from 'rxjs/operators'

@Injectable()
export class UpdateFavoriteProjectSortCommand {
  constructor(private httpClient: HttpClient) {}
  call(organizationId: number, favoritePositionIds: number[]): Observable<any> {
    const url = `${environment.api.pm}/organizations/${organizationId}/favorite_projects/sort`

    const params = { project_ids: favoritePositionIds }

    return this.httpClient.post(url, params).pipe(
      map(() => {
        return null
      })
    )
  }
}
